import React from "react";
import PropTypes from "prop-types";
import { SignedImage } from "../common/SignedImage";

function ViewGasSafeCard({ userProfile }) {
  const cardFrontExists = userProfile.gasSafeCardFront ? true : false;
  const cardRearExists = userProfile.gasSafeCardRear ? true : false;

  return (
    <div className="row">
      <div className="col-xs-12 col-md-6 d-flex flex-column align-items-center">
        <p className="text-muted mb-0">Front of card</p>
        {cardFrontExists ? (
          <SignedImage
            className="mb-3"
            src={userProfile.gasSafeCardFront.url}
            style={{ width: 200, maxWidth: "100%", height: undefined }}
          />
        ) : (
          <p>No document uploaded</p>
        )}
      </div>
      <div className="col-xs-12 col-md-6 d-flex flex-column align-items-center">
        <p className="text-muted mb-0">Rear of card</p>
        {cardRearExists ? (
          <SignedImage
            className="mb-3"
            src={userProfile.gasSafeCardRear.url}
            style={{ width: 200, maxWidth: "100%", height: undefined }}
          />
        ) : (
          <p>No document uploaded</p>
        )}
      </div>
    </div>
  );
}

ViewGasSafeCard.propTypes = {
  userProfile: PropTypes.object.isRequired,
};

export default ViewGasSafeCard;
